import React from 'react'
import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import {getLocationSetter} from 'utils/browserUtils'
import config from 'config'
import {HeaderLogo, LogosContainer} from './HeaderLogosStyles'

const SummitsPrimaryLogo = styled(HeaderLogo)`
  width: 60px;
  height: 35px;
  margin-right: 24px;
  margin-bottom: 3px;

  ${breakpoint('portrait')`
    width: 74px;
    height: 43px;
    margin-right: 40px;
    margin-bottom: 0px;
  `};
`

const SummitsSecondaryLogosContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const BlickLogo = styled(HeaderLogo)`
  height: 18px;

  ${breakpoint('portrait')`
    height: 22px;
  `};
`

const getLogosProps = ({theme, homeLink, lang}) => ({
  primary: {
    src: `${config.url}/assets/logo-26summits-black.svg`,
    onClick: getLocationSetter(`https://26summits.ch/${lang === 'fr' ? 'fr' : ''}`),
  },
  blick: {
    src: `${config.url}/assets/${theme.shell.header.icon.image}`,
    onClick: getLocationSetter(homeLink),
  },
})

const SummitsLogos = props => {
  const logosProps = getLogosProps(props)

  return (
    <LogosContainer>
      <SummitsPrimaryLogo src={logosProps.primary.src} onClick={logosProps.primary.onClick} />
      <SummitsSecondaryLogosContainer>
        <BlickLogo src={logosProps.blick.src} onClick={logosProps.blick.onClick} />
      </SummitsSecondaryLogosContainer>
    </LogosContainer>
  )
}

export default SummitsLogos
